import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const PARTNERS_BACKGROUND = '86b5e7c61a3c337b8beb25bf5388d66c.png'

// 图标后续可直接补充到对应项目的 image 字段。
const PARTNER_CATEGORIES = [
  { id: 'shopping', image: '2a9212a6427b83614efa0c2076ce6451.png', labelKey: 'aboutUs.partners.categories.shopping' },
  { id: 'dining', image: '14729d76388ebe8351c9f6d3aef4c590.png', labelKey: 'aboutUs.partners.categories.dining' },
  { id: 'hotel', image: '85e6cdbe1ad1f01000215e7a0dcfba0f.png', labelKey: 'aboutUs.partners.categories.hotel' },
  { id: 'airlines', image: '259dd43f1596134017230dc2a3d90c63.png', labelKey: 'aboutUs.partners.categories.airlines' },
  { id: 'airport', image: '097334f37e61a2a3cb68a35c7785e358.png', labelKey: 'aboutUs.partners.categories.airport' },
  { id: 'transportation', image: '55642056cd26e55062be5e75da6df173.png', labelKey: 'aboutUs.partners.categories.transportation' },
  { id: 'sightseeing', image: '758da4980c7f468b799eedb968f9d0b0.png', labelKey: 'aboutUs.partners.categories.sightseeing' },
  { id: 'luggageDelivery', image: '67a29cc2a5f499994dc7dde8819ea007.png', labelKey: 'aboutUs.partners.categories.luggageDelivery' },
  { id: 'vip', image: '58dfdfcc5bf43ced73752e2abbf5022e.png', labelKey: 'aboutUs.partners.categories.vip' },
  { id: 'taxRefund', image: '317ff2ef0ba57c2fd5f7c3dbb56c286f.png', labelKey: 'aboutUs.partners.categories.taxRefund' },
  { id: 'localServices', image: '13ca94ae0b8a674eed511ffab5fbfb23.png', labelKey: 'aboutUs.partners.categories.localServices' },
] as const

const BusinessPartners = () => (
  <section
    className="h-[412px] w-full bg-cover bg-center bg-no-repeat text-white"
    style={{ backgroundImage: `url(${preFixImgUrl(PARTNERS_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col items-center pt-[60px]">
      <LangText
        lngKey="aboutUs.partners.title"
        className="text-[36px] font-bold leading-[50px]"
      />

      <div className="mt-[12px] flex items-baseline gap-[8px] text-[20px] leading-[30px]">
        <LangText className="text-[20px] leading-[28px]" lngKey="aboutUs.partners.subtitle.prefix" />
        <LangText
          lngKey="aboutUs.partners.subtitle.count"
          className="text-[24px] font-bold leading-[34px]"
        />
        <LangText className="text-[20px] leading-[28px]"  lngKey="aboutUs.partners.subtitle.suffix" />
      </div>
      <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-white/15" />

      <div className="mt-[48px] grid w-full grid-cols-[repeat(11,minmax(0,1fr))]">
        {PARTNER_CATEGORIES.map((category) => (
          <div key={category.id} className="flex flex-col items-center min-w-0 group">
            <div className="flex h-[80px] w-[80px] items-center justify-center">
              {category.image && (
                <img
                  src={preFixImgUrl(category.image)}
                  alt=""
                  className="object-contain w-full h-full transition-transform duration-300 group-hover:scale-110"
                  draggable={false}
                />
              )}
            </div>
            <LangText
              lngKey={category.labelKey}
              className="mt-[16px] whitespace-nowrap text-[20px] leading-[28px]"
            />
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default BusinessPartners
